import React from "react";
import InputRadio from "../InputRadio/InputRadio";

import PrewButton from "../PrewButton/PrewButton";
import NextButton from "../NextButton/NextButton";

const PARTICIPATIONS_CHOICES = [
  {
    value: 1,
    title: "Физическое лицо ",
    helpText:
      "Для тех, кто хочет участвовать индивидуально или в качестве лидера креативной команды, не имеющей юридического лица",
  },
  {
    value: 2,
    title: "Юридическое лицо",
    helpText: "Для агентств и команд с юридическим лицом",
  },
];

function Step2(props) {
  const { participationType, setParticipationType, setStep } = props;

  return (
    <form action=".">
      <div className="mm-form__inner">
        <InputRadio
          title="Тип участия"
          choices={PARTICIPATIONS_CHOICES}
          name="participationType"
          onChange={setParticipationType}
          value={participationType}
        />
      </div>

      <div className="buttons-wrapper">
        <PrewButton
          onClick={() => {
            setStep(1);
            setParticipationType(null);
          }}
        />
        <NextButton
          disabled={participationType ? false : true}
          onClick={() => setStep(3)}
        />
      </div>
    </form>
  );
}

export default Step2;
